import Lightning from "@lightningjs/sdk/src/Lightning";
import ResumeInfoUI from "../../ui-elements/resume-info-ui";
import { ItemNode } from "../../lib/components/grid/ItemNode";
import { AppData, Log, Registry, Utils } from "@lightningjs/sdk";
import Router from "@lightningjs/sdk/src/Router";
import { AppSetup } from "../../lib/app-setup";
import { Helper } from "../../lib/helper";
import LableButton from "../../ui-elements/lable-button";
import ResumeButton from "../../ui-elements/resume-button";
import ResumeLabelButton from "../../ui-elements/resume-label-button";
import { Logger } from "../../lib/logger";
import { fetchData, postLikeDislikeUrl } from "../../lib/models/data-service";
import BackBarUI from "../../ui-elements/back-bar";


export interface MoreinfoWidgetTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class MoreinfoWidget
    extends Lightning.Component<MoreinfoWidgetTemplateSpec>
    implements Lightning.Component<MoreinfoWidgetTemplateSpec>
{

    _vodInfo!: ItemNode; //parent grid show thumbnail data
    _bdata!: ItemNode[]
    page!: any
    isBookmarApiLoaded = false
    isDeeplink = false //if is deeplink do not load the show again as it is already loaded in grid.
    resumeTime = '0'
    _index = 0;
    autoPlayTimerId: any;
    count = 0;
    autoPlayTime = 10;
    resumeType = 'bookmark' // 'bookmark' or resume'

    static override _template(): Lightning.Component.Template<MoreinfoWidgetTemplateSpec> {
        return {
            color: 0xff000000,
            rect: true,
            w: 1920,
            h: 1080,
            alpha: 0,
            collision:true,
            ItemInfo: {
                w: (w: any) => w,
                h: (h: any) => h,
                type: ResumeInfoUI,
                collision:true,
                alpha: 0,
                zIndex:61,
                background: './images/info_bg-236.png',
                displayActAndDir:true,
            },
            ButtonsWrapper: {
                x: 112,
                zIndex:62,
                y: (h: any) => h - 300,
                collision:true,
                Buttons: {
                    collision:true,
                    flex: { direction: "row"}
                },
            },
            BackBar: {
                x: 0,
                y: 0,
                type: BackBarUI,
                zIndex: 64,
                collision: true,
            },
            AutoPlayText: {
                visible: false,
                zIndex:63,
                x: (w: any) => 165,
                y: (h: any) => h - 180,
                flex: { direction: 'row' },
                Pre: {
                    text: {
                        text: "",
                        fontFace: "SFPro-Black",
                        letterSpacing: 0.82,
                        fontSize: 36,
                    },
                },
                Mid: {
                    //x: 480,
                    flexItem: { marginLeft: 10 },
                    text: {
                        text: "",
                        fontFace: "SFPro-Black",
                        letterSpacing: 0.82,
                        textColor: 0xffFF0000,
                        fontSize: 36,
                    },
                },
                Post: {
                    //x: 550,
                    flexItem: { marginLeft: 10 },
                    text: {
                        text: "",
                        fontFace: "SFPro-Black",
                        letterSpacing: 0.82,
                        fontSize: 36,
                    },
                }
            },
            visible: false
        }
    }

    $setbdata(vodInfo: ItemNode, isDeeplink = false) {
        this._vodInfo = vodInfo
        this.isDeeplink = isDeeplink
        this.resumeType = 'video'
        /*if (this._vodInfo.feed_type == 'video') {
            this.resumeType = 'video'
            Log.info('Resume Vod Info set,', this._vodInfo)
        } else {
            this.resumeType = 'bookmark'
            Log.info('Moreinfo Vod Info set,', this._vodInfo)
            //this._handleMoreinfoData()
        }*/
    }

    async _handleMoreinfoData() {
        this.isBookmarApiLoaded = false
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        let bdata = await app?.bookmarkingManager.checkMoreinfoAndLoadShows(this._vodInfo)
        if (bdata && bdata[1]?.season !== null && bdata[1]?.episode !== null && bdata[1]?.season !== '' && bdata[1]?.episode !== '') {
            this._bdata = bdata
            Log.info('Moreinfo bdata,', bdata)
            this.isBookmarApiLoaded = true
            this.page.widgets.loadingscreen.showLoadingScreen(false)
            this._update()
        } else {
            if (this.isDeeplink) {
                const vodInfo: ItemNode = app?.navigation.getCurrentGrid().getFocusedItem();
                Router.navigate('video-screen/' + vodInfo.node_id + '_resume', false)
            } else {
                Router.navigate(`mlp-grid-screen/${this._vodInfo.id}`, false)
            }
        }
    }

    _getActionKey() {
        let vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0]
        if (vodInfo) {
            return `${vodInfo.node_id}_${this.resumeTime}`
        }
        return ''
    }

    _updateAutoplayTimerText(sec) {
        this.patch({
            AutoPlayText: {
                Pre: {
                    text: {
                        text: 'Auto playing video in ...',
                    },
                },
                Mid: {
                    text: {
                        text: sec,
                    },
                },
                Post: {
                    //x:x,
                    text: {
                        text: " seconds",
                    },
                }
            },
        });
    }

    _update() {
        //let vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0]
        let vodInfo = this._vodInfo
        const feedType = this._vodInfo.feed_type;
        this.patch({
            ItemInfo: {
                item: vodInfo,
                alpha: 1,
            },
        });

        const { appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        const enableLikeDislike = appApiConfig?.appConfig?.enableLikeDislike === true;
        const buttons = Helper.moreInfoScreenButtons;
        const buttonsToAdd: any[] = []

        buttons.map((button: any, index) => {
            if (!enableLikeDislike &&  ["$like", "$love", "$dislike"].includes(button.action)) {
                return;
            }

            if (feedType === "category") {
                if (!["$back", "$like", "$love", "$dislike"].includes(button.action)) {
                    return;
                }
            } else {
                if (!["$begin", "$like", "$love", "$dislike"].includes(button.action)) {
                    return;
                }
            }


            if (this.resumeType == 'video') {
                this.isBookmarApiLoaded = true
                if (button.src) {
                    buttonsToAdd.push({
                        type: ResumeButton,
                        collision:true,
                        action: button.action,
                        label: button.label,
                        iconSrc: Utils.asset(button.src),
                        focusedSrc: Utils.asset(button.focusedSrc),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        zIndex: 62
                    })
                } else {
                    buttonsToAdd.push({
                        type: ResumeLabelButton,
                        action: button.action,
                        collision:true,
                        label: button.label,
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        zIndex: 62
                    })
                }
            } else {
                const seasonStr = (this._bdata[1]?.season.length == 1 ? '0' + this._bdata[1]?.season : this._bdata[1]?.season)
                const episodeStr = (this._bdata[1]?.episode.length == 1 ? '0' + this._bdata[1]?.episode : this._bdata[1]?.episode)

                if (button.src) {
                    buttonsToAdd.push({
                        type: ResumeButton,
                        action: button.action,
                        collision:true,
                        label: button.label,
                        iconSrc: Utils.asset(button.src),
                        focusedSrc: Utils.asset(button.focusedSrc),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        zIndex: 62
                    })
                } else {
                    buttonsToAdd.push({
                        type: ResumeLabelButton,
                        action: button.action,
                        collision:true,
                        label: (button.action == '$resume' ? `${button.label} S${seasonStr}E${episodeStr}` : button.label),
                        flexItem: { marginLeft: 50 },
                        w: button.width,
                        h: button.height,
                        zIndex: 62
                    })
                }
            }
        });
        this.tag("ButtonsWrapper.Buttons").children = buttonsToAdd
        this._refocus()
        //this.startAutoPlayTimer();
        Logger.processUserAction('videoResumePopup_open', this._getActionKey());
    }

    startAutoPlayTimer = () => {
        let timer = 1000;
        this.count = 0;
        if (!this.autoPlayTimerId) {
            this.autoPlayTimerId = Registry.setInterval(() => {
                if (this.count == this.autoPlayTime) {
                    Logger.processUserAction('videoResumePopup_autoPlayingOnInactivity', this._getActionKey());
                    this.$resume();
                }
                let sec = `${this.autoPlayTime - this.count}`;
                this.count++;
                /*let x=540;
                if(Number(sec)<10){
                  x=515;
                }*/
                this._updateAutoplayTimerText(sec)
            }, timer);
        }
    };

    stopAutoPlayTimer = () => {
        clearInterval(this.autoPlayTimerId);
        this.autoPlayTimerId = null;
    };

    $begin() {
        this.stopAutoPlayTimer();
        this.patch({
            visible: false
        });
        Logger.processUserAction('videoResumePopup_playFromBeginning');
        if (this.resumeType == 'video') {
            this.handleVideoResume('begin')
        } else {
            this.loadMlp('begin')
        }

        //this.fireAncestors("$handleBegin");
    }

    $resume() {
        this.stopAutoPlayTimer();
        Logger.processUserAction('videoResumePopup_playFromResumePoint');
        if (this.resumeType == 'video') {
            this.handleVideoResume('resume')
        } else {
            this.loadMlp('resume')
        }
        //this.fireAncestors("$handleResume");
    }

    $back() {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp();
        Logger.processUserAction('videoResumePopup_backByUser', this._getActionKey());
        this.stopAutoPlayTimer();
        if (this.resumeType == 'video') {
            //app?.handleBackNavigation()
            Router.focusPage()
            if(this.isDeeplink) {
                app?.handleBackNavigation()
            }
        } else {
            this.loadMlp('back')
        }
    }

    override _handleKey(e: KeyboardEvent) {
        Log.info('Moreinfo widget: _handleInfo ', e)
        if (this.isBookmarApiLoaded) {
            if (e.code == 'ArrowRight') {
                let len = this.tag("ButtonsWrapper.Buttons").children.length - 1;
                this._index = Math.min(len, this._index + 1);
            } else if (e.code == 'ArrowLeft') {
                this._index = Math.max(0, this._index - 1);
            }
        }
        return true
    }

    override _handleBack() {
        this.$back()
    }

    override _getFocused() {
        if (this.isBookmarApiLoaded) {
            return this.tag("ButtonsWrapper.Buttons").children[this._index];
        } else {
            return null
        }
    }


    /**
     * _focus is a Lightning component lifecycle method.
     * it will be triggered when the component gets focus.
     * As it is triggered via Router.focusWidget('bookmark')
     * the resume will overlay over the page and it will get focus.
     */
    override _focus() {
        const isFirstOpen = !this.visible;
        this.fireAncestors('$toggleMenuVisibility' as any, false)
        this.patch({
            alpha: 1,
            item: this._vodInfo,
            visible: true,
        })
        if (isFirstOpen) {
            this._index = 0;
        }
        //Resetting the initial display seting as 10 fix for XFIN-XFIN-678
        this.autoPlayTime = 10
        this.count = 0
        let sec = `${this.autoPlayTime - this.count}`;
        this._updateAutoplayTimerText(sec)
        //this.page.widgets.loadingscreen.showLoadingScreen(true)
        if(this.resumeType == 'video') {
            //this.page.widgets.loadingscreen.showLoadingScreen(false)
            //this.page.widgets.loadingscreen.showVideoLoadingScreen(true)
            this._update()
        } else {
            this._update()
            //this.page.widgets.loadingscreen.showLoadingScreen(true)
            //this._handleMoreinfoData()
        }
        Log.info('Moreinfo _focus')

    }

    override _unfocus() {
        this.fireAncestors('$toggleMenuVisibility' as any, true)
        this.patch({
            alpha: 0,
            visible: false,
        })
        this.page.widgets.loadingscreen.showLoadingScreen(false)
        this.page.widgets.loadingscreen.showVideoLoadingScreen(false)
        Log.info('Moreinfo _unfocus')
    }

    override _onActivated(page: any) {
        this.page = page
        this._index = 0
        Log.info('Moreinfo Activated')
    }

    /**
     * An async function handles the MLP loading and when loading is done
     * finds the exact Season and Episode to be played and navigate to video screen.
     * Video screen to play the exact node.
     * @async
     * @param {string} buttonType
     * @returns {*}
     */
    async loadMlp(buttonType: string) {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        if (buttonType == ('resume' || 'begin')) {
            this.page.widgets.loadingscreen.showVideoLoadingScreen(true)
        } else {
            this.page.widgets.loadingscreen.showLoadingScreen(true)
        }
        if (!this.isDeeplink) {
            await app?.bookmarkingManager.loadMlp(this._vodInfo, this._bdata[1])
        } else {
            const currGrid = app?.navigation.getCurrentGrid()!
            const _episodeVodInfo = this._bdata[1]!
            await currGrid.findAndLoadSeasonEpisode(_episodeVodInfo.season, _episodeVodInfo.episode)
        }
        if (buttonType == 'resume') {
            Router.navigate('video-screen/' + this._bdata[0]?.node_id + '_resume', false) //fix for XFIN-666 - changed from '_bookmarkresume' to 'resume'
        } else if (buttonType == 'begin') {
            Router.navigate('video-screen/' + this._bdata[0]?.node_id + '_begin', false) //fix for XFIN-666 - changed from '_bookmarkbegin' to 'begin'
        } else {
            if (this.isDeeplink) {
                const vodInfo: ItemNode = app?.navigation.getCurrentGrid().getFocusedItem();
                app?.handleBackNavigation()
            } else {
                Router.navigate(`mlp-grid-screen/${this._vodInfo.id}`, false)
            }
        }
    }


    handleVideoResume(buttonType: string) {
        if (buttonType == 'resume') {
            Router.navigate('video-screen/' + this._vodInfo?.node_id + '_resume', false)
        } else if (buttonType == 'begin') {
            Router.navigate('video-screen/' + this._vodInfo?.node_id + '_begin', false)
        }
    }

    _handleClick(target) {
        if(target && target.action) {
            this[target.action]()
        }
    }

    $onButtonClick(button: any) {
        const buttons = this.tag("ButtonsWrapper.Buttons").children;
        const idx = buttons.indexOf(button);
        if (idx >= 0 && idx !== this._index) {
            this._index = idx;
            this._refocus();
        }
    }

    $handleBackButton() {
        this.$back();
    }

    $like() {
        this.handleRating(1);
    }

    $love() {
        this.handleRating(2);
    }

    $dislike() {
        this.handleRating(3);
    }

    handleRating(likeValue: number) {
        const vodInfo = this.resumeType == 'video' ? this._vodInfo : this._bdata[0];
        const listType = "node" || "list"
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        const grid = app?.navigation.getCurrentGrid()
        if (!vodInfo) return;

        if (vodInfo.likedislike === likeValue) {
            likeValue = 0;
        }

        vodInfo.likedislike = likeValue;
        const itemInfo: any = this.tag('ItemInfo');
        if (itemInfo) {
            itemInfo.item = vodInfo
        }
        if (likeValue !== undefined && likeValue !== null) {
            grid?.updateItemLikeStatus(likeValue, false)
        }
        const url = postLikeDislikeUrl(vodInfo.node_id, listType, likeValue);
        let actionLabel = "Remove";
        let notificationMessage = "Rating removed!";
        if (likeValue === 1) {
            actionLabel = "Like";
            notificationMessage = "Liked!";
        } else if (likeValue === 2) {
            actionLabel = "Love";
            notificationMessage = "Loved it!";
        } else if (likeValue === 3) {
            actionLabel = "Dislike";
            notificationMessage = "Not for me!";
        }
        Logger.processUserAction('Like_Dislike_Feature_' + actionLabel, vodInfo.node_id);
        fetchData(url)
            .then((response) => {
                if (response.data.status === 1) {
                    Log.info("MoreInfoWidget: Like/DislikeElemStatus: itemId, itemType, newItemVal", vodInfo.node_id, listType, likeValue);
                    Router.getActivePage()?.widgets.notification.showNotification(notificationMessage);
                }
            })
            .catch((err) => {
                Log.error("MoreInfoWidget: API call failed:", err.message);
            });
    }
}
